"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_calendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "calendar-mid"), /*#__PURE__*/React.createElement("g", {
    id: "360eb50e-392a-4dfa-9865-6ece1ef3654d",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b7c99ed9-da3e-4b38-be16-955ea7b055ac",
    "data-name": "Business_ic_mid"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 164,
    y1: 68,
    x2: 28,
    y2: 68,
    fill: "none",
    stroke: "#e60000",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "bbe0b2aa-cf89-4015-bde3-d26237796124",
    "data-name": "<Pfad>",
    x1: 66,
    y1: 18,
    x2: 66,
    y2: 46,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "b58c824d-1a75-426f-acb1-2b2a6c57bcd3",
    "data-name": "<Pfad>",
    x1: 126,
    y1: 18,
    x2: 126,
    y2: 46,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 34,
    width: 140,
    height: 140,
    rx: 12,
    ry: 12,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.68,115.36A20.38,20.38,0,0,1,76.5,115c9.66,0,17.5,6.72,17.5,15s-7.84,16-17.5,16A16.35,16.35,0,0,1,62,138",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "62 96 92 96 72.63 115.37",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "112 104 128 94 128 146",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }))));
}

var _default = ic_calendar;
exports.default = _default;